var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"services"},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t("page.referralForm.services.title")))]),_c('div',{staticClass:"main-info-block"},_vm._l((_vm.services),function(service,index){return _c('ServiceInfoBlock',{key:index,staticClass:"service-info-block",attrs:{"service":service}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }